import { IBusinessConfigs } from '../_Common/Const/BusinessConfigs';
import { initConst } from '../../../Utils/utils';

const MUBusinessConfig = initConst<IBusinessConfigs>(() => ({
  MUMusikstycke: {
    defaultColumns: [
      { attributeDef: 'TITEL', caption: 'Titel' },
      { attributeDef: 'ALT_TITEL', caption: 'Alternativ titel' },
      { attributeDef: 'TONS_MEL', caption: 'Tonsättare' },
      { attributeDef: 'ARR', caption: 'Arrangör' },
      { attributeDef: 'TEXT_F', caption: 'Textförfattare' },
      { attributeDef: 'T_BEARB', caption: 'Övers./Textb' },
      { attributeDef: 'KOMPAR', caption: 'Kompositionsår' },
      { attributeDef: 'SPR', caption: 'Språk' },
      { attributeDef: 'OMFATTN', caption: 'Omfattning' },
      { attributeDef: 'STTN', caption: 'Vokalbesättning' },
      { attributeDef: 'INSTRBES', caption: 'Instrumentbesättning' },
      { attributeDef: 'OVRSTTN', caption: 'Övrig sättningsinformation' },
      { attributeDef: 'BRUK', caption: 'Tillfälle' },
      { attributeDef: 'BRUK2', caption: 'Genre' },
      { attributeDef: 'FLAG', caption: 'Förlag' },
      { attributeDef: 'Samling', caption: 'Samling' },
      { attributeDef: 'UTGAVOR', caption: 'Utgåvor' },
      { attributeDef: 'FLAGNR', caption: 'Artikelnummer' },
      { attributeDef: 'UTGIVEN', caption: 'Utgivningsår' },
      { attributeDef: 'COPYRIGHT', caption: 'Copyright' },
      { attributeDef: 'PrefixID', caption: 'Prefix ID' },
      { attributeDef: 'SAML', caption: 'Samling' },
    ],
  },
  MUForfattare: {
    defaultColumns: [
      { attributeDef: 'NAMN', caption: 'Namn' },
      { attributeDef: 'LEVNADSAR', caption: 'Levnadsår' },
      { attributeDef: 'Profession', caption: 'Profession' },
      { attributeDef: 'BIOGRAFI', caption: 'Biografi' },
      { attributeDef: 'PrefixID', caption: 'ID' },
    ],
  },
  MUArkiv: {
    defaultColumns: [
      { attributeDef: 'GRUPP', caption: 'Grupp' },
      { attributeDef: 'ARKIV', caption: 'Arkiv' },
    ],
  },
  MUArkivinformation: {
    defaultColumns: [
      { attributeDef: 'NotArk.GRUPP', caption: 'Grupp' },
      { attributeDef: 'NotArk.ARKIV', caption: 'Arkiv' },
      { attributeDef: 'UNDERNIVA_1', caption: 'Skåp/hylla' },
      { attributeDef: 'UNDERNIVA_2', caption: 'Mapp' },
      { attributeDef: 'NotMus.TONS_MEL', caption: 'Tonsättare' },
      { attributeDef: 'NotMus.TITEL', caption: 'Titel' },
      { attributeDef: 'NotMus.STTN', caption: 'Vokalbesättning' },
      { attributeDef: 'NotMus.INSTRBES', caption: 'Instrumentbesättning' },
      { attributeDef: 'NotMus.FLAG', caption: 'Förlag' },
      { attributeDef: 'NotMus.FLAGNR', caption: 'Artikelnummer' },
      { attributeDef: 'ANTAL_EX', caption: 'Antal ex.' },
    ],
  },
  MUFramforande: {
    defaultColumns: [
      { attributeDef: 'DATUM', caption: 'Datum' },
      { attributeDef: 'PLATS', caption: 'Plats' },
      { attributeDef: 'LoggMus.TITEL', caption: 'Titel' },
      { attributeDef: 'LoggMus.ALT_TITEL', caption: 'Alternativ titel' },
      { attributeDef: 'LoggMus.TONS_MEL', caption: 'Tonsättare' },
      { attributeDef: 'LoggMus.ARR', caption: 'Arrangör' },
      { attributeDef: 'LoggMus.TEXT_F', caption: 'Textförfattare' },
      { attributeDef: 'LoggMus.FLAG', caption: 'Förlag' },
      { attributeDef: 'LoggMus.FLAGNR', caption: 'Artikelnummer' },
      { attributeDef: 'LoggMus.PrefixID', caption: 'Prefix ID från LoggMus' },
    ],
  },
}));

export default MUBusinessConfig;
